import { render, staticRenderFns } from "./TicketDates.vue?vue&type=template&id=0be2e0c6&scoped=true"
import script from "./TicketDates.vue?vue&type=script&lang=js"
export * from "./TicketDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be2e0c6",
  null
  
)

export default component.exports